import { useMemo } from 'react'

import { get } from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'

import profileActions from '../actions/profile'

export const useProfile = () => {
  const data = useSelector((state) => {
    return get(state, 'app.profileManagement')
  })

  const dispatch = useDispatch()
  const actions = useMemo(
    () => bindActionCreators(profileActions, dispatch),
    [dispatch],
  )

  return {
    actions,
    data,
  }
}
